import React from 'react';
import styled from 'styled-components';

const Overlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Darkened, transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Increased z-index to be higher than all other components (others use 9999) */
`;

const Spinner = styled('div')`
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

interface SpinnerOverlayProps {
  isVisible: boolean;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <Overlay>
      <Spinner />
    </Overlay>
  );
};

export default SpinnerOverlay;
